<template>
  <page-outline :title="$t('administration.user_details')">
    <template slot="pageContent">
      <b-row class="pb-3 mx-0 no-gutters">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <template v-else-if="User">
        <div class="title-label-blue w-200px">{{$t('administration.user_info')}}</div>
        <table class="table">
          <tbody>
              <tr>
                <th class="text-center w-50">
                  {{ $t('administration.identifier') }}
                </th>
                <td class="text-center">
                  {{ User.Login }}
                </td>
              </tr>
              <tr v-if="User.Name">
                <th class="text-center w-50">
                  {{ $t('administration.user_name') }}
                </th>
                <td class="text-center">
                  {{ User.Name }}
                </td>
              </tr>
              <tr>
                <th class="text-center w-50">
                  {{ $t('administration.active') }}
                </th>
                <td class="text-center w-50">
                  <i v-if="User.Active == 0" class="fa-duotone fa-xmark btn btn-icon btn-icon-red p-0 min-h-auto"></i>
                  <i v-if="User.Active == 2" class="fa-duotone fa-check btn btn-icon btn-icon-green p-0 min-h-auto"></i>
                  <i v-if="User.Active == 1" class="fa-duotone fa-warning btn btn-icon btn-icon-orange p-0 min-h-auto"></i>
                </td>
              </tr>
          </tbody>
        </table>
        <br>
        <div class="title-label-blue w-200px">{{$t('administration.user_auth')}}</div>
        <table class="table" v-if="User.Rights && User.Rights.length">
          <tbody>
            <tr>
              <th class="text-center w-50">
                {{ $t('administration.company_name') }}
              </th>
              <th class="text-center w-50">
                {{ $t('administration.profile') }}
              </th>
            </tr>
            <tr v-for="right in User.Rights" :key="right.IdAccount + '-' + right.IdRightProfile">
              <td class="text-center w-50">
                {{ right.AccountName }}
              </td>
              <td class="text-center w-50">
                {{ right.RightsProfileName }}
              </td>
            </tr>
          </tbody>
        </table>
        <br>
        <b-row class="justify-content-end">
          <b-button v-if="canUserEdit" class="btn mx-3" variant="primary" @click="activateEdit(User.IdUser)">
            <i class="fa-light fa-pencil"></i> {{ $t('administration.user_edit') }}
          </b-button>
          <b-button v-if="canUserDelete" class="btn mx-3" variant="primary" @click="activateDelete(User.IdUser)">
            <i class="fa-light fa-trash"></i> {{ $t('administration.user_delete') }}
          </b-button>
        </b-row>
      </template>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'
import {errorMessageAlert} from '@/helpers/alert'
import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage, reloadPage} from '@/helpers/routing'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'

export default {
  name: 'DetailUserCompany',
  components: {
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    canUserDelete () {
      return this.$engine.rights.rightIs('usercompany_supprimer', true) || this.$engine.rights.rightIs('usercompany_supprimer_admin', true)
    },
    canUserEdit () {
      return this.$engine.rights.rightIs('usercompany_editer', true) || this.$engine.rights.rightIs('usercompany_editer_admin', true)
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      return 'Details de l\'utilisateur'
    }
  },
  props: ['idUserAcc', 'idCompany'],
  data () {
    return {
      activateSpinner: false,
      returnUrl: '/detail/',
      User: {}
    }
  },
  created () {
    this.returnUrl += this.idCompany
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'utilisateur',
      // returnUrl: ''
    })

    this.$engine.settings.set({msgDirection: this.direction})
    this.getUser()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    getUser () {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = that.$engine.usercompany.getConditionObject()
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      that.$engine.usercompany.getUser(
        this.idUserAcc,
        10,
        1,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.users && resp.data.users.length) {
          let userCompany = resp.data.users[0]
          that.User = userCompany
          this.$f7.pullToRefreshDone()
          this.$bus.$emit('refresh-cache-paging-template', this.paginationObject)
        }
        this.activateSpinner = false
      }).catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    activateEdit (ressource) {
      let that = this
      loadPage(that, {url: '/editusercompany/' + ressource + '/' + that.idCompany})
    },
    activateDelete (ressource) {
      let that = this
      this.$f7.modal({
        title: this.$i18n.t('administration.del_user_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.usercompany.deleteUser(ressource)
              .then(resp => {
                that.$f7.alert('', that.$t('administration.del_user'))
                reloadPage(that, {url: '/detail/' + that.idCompany})
              }).catch(e => {
                errorMessageAlert(e, that)
                that.$f7.modal({
                  title: that.$i18n.t('administration.del_error'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
